import { Col, Form, Input, Radio, Row } from 'antd';
import { localize } from 'mixins/helpers';
import Button from 'mixins/ui/button/button';
import React from 'react';
import Recaptcha from '/react4xp/mixins/ui/recaptcha/recaptcha';
import UkmNew1Image from '/react4xp/parts/find-ukm/assets/ukm-new-1.jpg';
import UkmNew2Image from '/react4xp/parts/find-ukm/assets/ukm-new-2.jpg';
import UkmOld1Image from '/react4xp/parts/find-ukm/assets/ukm-old-1.jpg';
import UkmOld2Image from '/react4xp/parts/find-ukm/assets/ukm-old-2.jpg';

const ByHand = ({
    ukmType,
    setUkmType,
    clearForm,
    loading,
    onFinish,
    captchaRef,
    form,
    ...props
}) => {
    const { series, number } = props.config;
    return (
        <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
        >
            <Radio.Group
                value={ukmType}
                className={'handRadio'}
                onChange={(e) => setUkmType(e.target.value)}
            >
                <Radio value="new">
                    <p>{localize('find-ukm-new-sample-ukm', props.translations)}</p>
                    <img
                        src={UkmNew1Image}
                        width={400}
                        height={105}
                    />
                    <img
                        src={UkmNew2Image}
                        width={400}
                        height={105}
                    />
                </Radio>
                <Radio value="old">
                    <p>{localize('find-ukm-old-sample-ukm', props.translations)}</p>
                    <img
                        src={UkmOld2Image}
                        width={400}
                        height={105}
                    />
                    <img
                        src={UkmOld1Image}
                        width={400}
                        height={105}
                    />
                </Radio>
            </Radio.Group>
            <Row gutter={16}>
                <Col
                    xs={24}
                    md={12}
                    lg={5}
                >
                    <Form.Item
                        label={series}
                        name="series"
                        rules={[
                            {
                                required: true,
                                pattern: ukmType == 'new' ? /^[a-zA-Z]+$/ : /^[а-яА-ЯёЁ]+$/,
                                message: localize(
                                    ukmType == 'new' ? 'error.only-latin' : 'error.only-cyrillic',
                                    props.commonTranslations
                                ),
                            },
                        ]}
                    >
                        <Input
                            maxLength={2}
                            size="large"
                            placeholder={localize('placeholder.input', props.commonTranslations)}
                        />
                    </Form.Item>
                </Col>
                <Col
                    xs={24}
                    md={12}
                    lg={5}
                >
                    <Form.Item
                        label={number}
                        name="number"
                        rules={[
                            {
                                required: true,
                                pattern: /^[0-9]{9,9}$/,
                                message: localize(
                                    'error.number-length-9',
                                    props.commonTranslations
                                ),
                            },
                        ]}
                    >
                        <Input
                            maxLength={9}
                            size="large"
                            placeholder={localize('placeholder.input', props.commonTranslations)}
                        />
                    </Form.Item>
                </Col>
            </Row>

            <Recaptcha
                ref={captchaRef}
                lang={props.lang}
            />

            <hr className="my-3" />

            <Row gutter={{ xs: 8, md: 16 }}>
                <Col>
                    <Button onClick={clearForm}>
                        {localize('button.reset', props.commonTranslations)}
                    </Button>
                </Col>
                <Col>
                    <Button
                        color="gold"
                        htmlType="submit"
                        loading={loading}
                    >
                        {localize('button.find', props.commonTranslations)}
                    </Button>
                </Col>
            </Row>

            {loading && (
                <p
                    style={{
                        marginTop: 10,
                    }}
                >
                    {localize('find-ukm-wait-server-request', props.translations)}
                </p>
            )}
        </Form>
    );
};

export default ByHand;
